import React from 'react';

import styles from './SortableTableHeaderCell.scss';
import {
  Sort,
  SortDown,
  SortUp,
} from '../icons/Icons.jsx';

let icons = {
  ascending: <SortUp className={styles.sortIcon} />,
  descending: <SortDown className={styles.sortIcon} />,
  hover: <Sort className={styles.sortIcon} />,
};

export default icons;
